import axios from 'axios'

const axiosInstance = axios.create({
  headers: {
    token: localStorage.getItem("storageTokenKeyName")
  },
  withCredentials: true,
  // baseURL: 'http://20.20.20.65:7000/'
  baseURL: 'https://legal.rsii.id/'

})

export default axiosInstance